import type { MenuProps } from 'antd'
import { FloatingNav } from '@/components/ui/floating-navbar'
import { useThemeStore } from '@/stores/theme'
import { MoonOutlined, SunOutlined } from '@ant-design/icons'
import { Button, Dropdown, FloatButton, theme } from 'antd'
import { Content } from 'antd/es/layout/layout'
import { useTranslation } from 'react-i18next'
import { useLoginStore } from '@/stores/login'
import LoginForm from '@/components/login-form'

function BaseLayout({ children }: { children: React.ReactNode }) {
  const { t, i18n } = useTranslation()
  const { mode, setMode } = useThemeStore()
  const { setFormType } = useLoginStore()
  const { token } = theme.useToken()
  const items = useMemo(() => [{
    key: 'zh',
    label: `中文(zh)`,
  }, {
    key: 'en',
    label: `English(en)`,
  }, {
    key: 'ru',
    label: `Русский(ru)`,
  }], [])
  const onClick: MenuProps['onClick'] = ({ key }) => {
    i18n.changeLanguage(key)
    localStorage.setItem('LANGUAGE', key)
  }
  const navItems = [{
    name: t('home'),
    link: '/',
  }, {
    name: t('plan'),
    link: '/plan',
  }, {
    name: t('download'),
    link: '/download',
  }, {
    name: t('contact'),
    link: '/contact',
  }]
  return (
    <Content className="flex flex-col min-h-screen juxtify-between" style={{ backgroundColor: token?.colorBgBase }}>
      <FloatingNav navItems={navItems}>
        <Button size="small" type='primary' onClick={() => setFormType('login')}>Login</Button>
      </FloatingNav>

      <section className="flex-1 py-8">
        {children}
      </section>
      <footer className="bottom-0 z-10 flex items-center justify-center px-4 py-2 transition-transform duration-300 shadow-md">
        <p className="text-sm text-gray-500">
          © 2023 Open Gate
        </p>
      </footer>
      <div className="fixed space-x-2 bottom-4 right-3">
        <Button
          icon={mode === 'dark' ? <SunOutlined size={24} /> : <MoonOutlined />}
          onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
        />
        <Dropdown trigger={['click']} menu={{ items, onClick }}>
          <Button
            variant="solid"
            icon={<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 8l6 6m-7 0l6-6l2-3M2 5h12M7 2h1m14 20l-5-10l-5 10m2-4h6"></path></svg>}
          />
        </Dropdown>
      </div>
      <LoginForm />
      <FloatButton.BackTop />
    </Content>
  )
}

export default BaseLayout
